import React from 'react';
import {Box, FormControl, Input} from 'native-base';

import {defaultProps} from './../../../../../../../components/inputs/constants';

const ReadonlyInput = ({
  value,
  label,
  icon,
}: {
  value: string;
  label: string;
  icon: any;
}) => {
  const InternalIcon = () => <Box marginLeft={5}>{icon}</Box>;

  return (
    <Box width="100%" marginBottom={5}>
      <FormControl>
        <FormControl.Label>{label}</FormControl.Label>
        <Input
          InputLeftElement={<InternalIcon />}
          {...defaultProps}
          backgroundColor={'white'}
          value={value}
          isReadOnly={true}
          _input={{
            color: '#858597',
          }}
        />
      </FormControl>
    </Box>
  );
};

export default ReadonlyInput;
